
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHelp as ObiHelpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-help.js';
 
 
 

 
 export const ObiHelp = createComponent({
   react: React,
   tagName: 'obi-help',
   elementClass: ObiHelpElement,
   events: {
     
   }
  });
 
 